var App = App || {};

App.Base = (function ($) {
    'use strict';

    var $body = $('body');

    function init() {
        HashSupport();
        ZagParallaxExample();

        $("a").each(function () {
            if ($(this).hasClass("baconpay")) {
                $(this).attr("onclick", "createBaconWebClient('2a773903-7d62-426e-9ff5-c2b6ead0163e', 'https://web.baconpay.com');");
            }
            else if ($(this).hasClass("initchat") || ($(this).attr("href") !== undefined && $(this).attr("href").indexOf("#initchat") != -1)) {
                $(this).on("click", function () {
                    if ($("#salemove").length > 0) {
                        document.getElementById("salemove").querySelector('.sm-reactive-tab').click();
                    }
                });
            }
        });


    }

    function HashSupport() {

        const Hash = $(location.hash);

        if (Hash.length == 1) {

            if (Hash.attr("data-bs-toggle") == "collapse") {
                const Target = $(Hash.attr("data-bs-target"));
                const Panel = document.getElementById(Target.attr("id"));
                const Collapse = new bootstrap.Collapse(Panel);
                Collapse.show();
            }

            else if (Hash.attr("data-bs-toggle") == "tab") {
                const Tab = new bootstrap.Tab(Hash);
                Tab.show();
            }

            else if (Hash.hasClass("modal")) {
                const Modal = new bootstrap.Modal(Hash);
                Modal.show();
            }
        }
    }

    function ZagParallaxExample() {
        $(".page-masthead .page-masthead-image").ZagParallax({ divisor: 2 });
    }

    // https://davidwalsh.name/query-string-javascript


    function addOverlay() {
        $body.addClass('has-overlay');
    }

    function removeOverlay() {
        $body.removeClass('has-overlay');
    }

    onScrollInit($('.os-animation'));

    $('[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
        Waypoint.refreshAll();
    });

    $('.staggered-animation').each(function () {
        var $this = $(this);
        onScrollInit($this, $this.parents('.staggered-animation-container'));
    });

    function onScrollInit(items, $trigger) {
        items.each(function () {
            var $osElement = $(this),
                osAnimationClass = $osElement.attr('data-os-animation'),
                osAnimationDelay = $osElement.attr('data-os-animation-delay');

            $osElement.css({
                '-webkit-animation-delay': osAnimationDelay,
                '-moz-animation-delay': osAnimationDelay,
                'animation-delay': osAnimationDelay
            });

            var $osTrigger = ($trigger) ? $trigger : $osElement;

            $osTrigger.waypoint(function () {
                $osElement
                    .one('animationend', function () {
                        $osElement
                            .addClass('animation-complete')
                            .removeClass('animate__animated');
                    })
                    .addClass('animate__animated')
                    .addClass(osAnimationClass);
            }, {
                triggerOnce: true,
                offset: '90%'
            });
        });
    }
    $('iframe.responsive').each(function () {
        $(this).iFrameResize();
    });

    function GetUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    $(".home-banner-jump-anchor .btn-down").on("click", function () {
        var duration = 100,
            offset = $(".home-banner").outerHeight();

        if (matchMedia("screen and (max-width: 992px)").matches) {
            var offset = $(".home-banner").outerHeight() - 200
        }

        $('html, body').stop()
            .animate({
                scrollTop: offset
            }, duration);
    })

    $(function () {
        $('[data-toggle="tooltip"]').tooltip();
    });

    return {
        init: init,
        $body: $body,
        addOverlay: addOverlay,
        removeOverlay: removeOverlay,
        GetUrlParameter: GetUrlParameter
    };

})(jQuery);

$(function () {
    App.Base.init();
});